import { queryOptions, useSuspenseQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";

import { AdminResult, type SessionResultData } from "@/pages/admin/result";

const sessionQueryOptions = (url: string, session_token: string) =>
  queryOptions<SessionResultData>({
    queryKey: ["session", session_token],
    meta: {
      url,
    },
  });

function createUrl(session_token: string) {
  const lang = localStorage.getItem("elara-lang") || "en";
  const url_params = new URLSearchParams();
  url_params.set("lang", lang);
  return `/session/${session_token}/results?${url_params.toString()}`;
}

export const Route = createFileRoute("/session/$session_token/results/$")({
  component: RouteComponent,
  loader: ({ context: { queryClient }, params: { session_token } }) => {
    const url = createUrl(session_token);
    return queryClient.ensureQueryData(sessionQueryOptions(url, session_token));
  },
});

function RouteComponent() {
  const { session_token } = Route.useParams();
  const url = createUrl(session_token);
  const { data: session_data } = useSuspenseQuery<SessionResultData>(
    sessionQueryOptions(url, session_token),
  );
  return <AdminResult session_data={session_data} />;
}
